module.exports = __webpack_public_path__ + "img/avatar1.fe5f695e.png";